import React, { Component } from "react";
import LoginComponent from "./components/login/index";
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import UploadComponent from "./components/upload-pfx";
import SignatureComponent from "./components/signature";
import { history } from "./components/config/global-router";
import TestSignature from "./components/test-signing/TestSignature";
const App = () => {
  return (
    <>
      <Router history={history}>
        <Routes>
          <Route index path="/" element={<LoginComponent />} />
          <Route index path="/login" element={<LoginComponent />} />
          <Route index path="/certificates" element={<UploadComponent />} />
          <Route index path="/signature" element={<SignatureComponent />} />
          <Route index path="/test" element={<TestSignature />} />
        </Routes>
      </Router>

    </>
  );
};

export default App;
